<!-- LATERAL MENU -->
<div class="h-full border-r-[1px]">
    <div class="h-40 flex flex-col items-center justify-evenly">
        <span *ngIf="isClient()" class="flex items-center text-xs">
            <mat-icon class="rotate-90 scale-75">account_tree</mat-icon>
            <span>{{ id_maitre }}</span>
        </span>
        <span *ngIf="!isClient()" class="flex items-center text-xs cursor-pointer" (click)="openPluginParentFolder()">
            <mat-icon class="rotate-90 scale-75">account_tree</mat-icon>
            <span>{{ id_maitre }}</span>
        </span>
        <span class="flex flex-col items-center justify-center text-center text-sm">
            <!-- <span>{{ 'INFORMATIONS' | translate }}</span> -->
            <ng-container *ngIf="type === 'intern'">
                <mat-icon class="!size-4" svgIcon="check-mark"></mat-icon>
                <span>{{ 'INTERN_REVISIONS_INFO' | translate }}</span>
            </ng-container>
            <ng-container *ngIf="type === 'extern'">
                <mat-icon class="!size-4" svgIcon="visibility"></mat-icon>
                <span *ngIf="isClientOnly">{{ 'CLIENT_REVISIONS_INFO' | translate }}</span>
                <span *ngIf="!isClientOnly">{{ 'EXTERN_REVISIONS_INFO' | translate }}</span>
            </ng-container>
            <ng-container *ngIf="type === 'revisions'">
                <mat-icon class="!size-4" svgIcon="compare_arrows"></mat-icon>
                <span>{{ 'VERSION_REVISIONS_INFO' | translate }}</span>
            </ng-container>
        </span>
    </div>
    <ng-container *ngIf="type === 'intern' || type === 'extern'">
        <div>
            <div class="w-full h-10 flex items-center justify-center text-sm" [ngClass]="'bg-'+getSlugText(displayedState?.slug || '')"> {{ userType | uppercase | translate }} </div>
            <div *ngIf="hasDecision" class="h-28 flex flex-col justify-center items-center border-b-2 border-dashed">
                <mat-icon [svgIcon]="'playlist-checked'"></mat-icon>
                <span>{{ 'CONTROL' | translate }}</span>
            </div>
        </div>
        <div class="h-24 flex flex-col justify-center items-center border-b-2">
            <mat-icon>group_user</mat-icon>
            <span>{{ 'MEMBERS' | translate}}</span>
        </div>
        <div  *ngIf="enable_attachments && has_attachements_flow" class="h-36 flex flex-col justify-center items-center border-b-2 border-dashed">
            <mat-icon>attach_file</mat-icon>
            <span>{{ 'PJ' | translate}}</span>
        </div>
        <div *ngIf="has_textes_flow" class="flex flex-col justify-center items-center">
            <div class="flex flex-col justify-center items-center min-h-40">
                <mat-icon>description</mat-icon>
                <span>{{ 'PRODUCTION_TEXTS.NAME' | translate}}</span>
            </div>
            <div *ngIf="textes" class="flex flex-col justify-start items-center">
                <button class="p-1 h-16 w-full border-b-2" [disabled]="display === 'legal'" [ngClass]="{'font-bold bg-tw-lightgrey':display === 'legal'}" (click)="display = 'legal'; $event.stopPropagation()">{{ 'PRODUCTION_TEXTS.LEGAL' | translate }}</button>
                <button class="p-1 h-16 w-full border-b-2" [disabled]="display === 'marketing'" [ngClass]="{'font-bold bg-tw-lightgrey':display === 'marketing'}" (click)="display = 'marketing'; $event.stopPropagation()">{{ 'PRODUCTION_TEXTS.MARKETING' | translate }}</button>
                <button class="p-1 h-16 w-full" [disabled]="display === 'tvn'" [ngClass]="{'font-bold bg-tw-lightgrey':display === 'tvn'}" (click)="display = 'tvn'; $event.stopPropagation()">{{ 'PRODUCTION_TEXTS.TVN' | translate }}</button>
            </div>
        </div>

    </ng-container>
    <ng-container *ngIf="type === 'revisions'">
        <div class="h-40 border-t-2 bg-tw-lightgrey flex flex-col justify-center items-center">
            <mat-icon [svgIcon]="'compare_arrows'"></mat-icon>
            <span>{{ 'COMPARE' | translate }}</span>
        </div>
    </ng-container>
</div>